export const hotelCategories = {
  resort: "Resort",
  allInclusive: "All-inclusive property",
  villa: "Villa",
  ryokan: "Ryokan",
};
